let config

// console.log(process.env.NODE_ENV)

if (process.env.NODE_ENV === 'production') {
  config = {
    apiUrl: 'https://api.expodogs.es/api', // "https://ws.eisi.cc/expodogs/api",
    timeoutDuration: 30000,
    someOtherProps: 'xyz',
    login: {
      username: null,
      password: null
    }
  }
} else {
  config = {
    apiUrl: 'http://api.test/api',
    // apiUrl: "http://localhost:8000/api",
    oauth: {
      url: 'https://fmrf.eisi.cc/oauth',
      secret: 'hNOmiCqPzKKZzAs7ggRUaZaHsGYU1RBJQriHVvla',
      grantType: 'password',
      clientId: '2'
    },
    login: {
      username: '',
      password: ''
    },
    timeoutDuration: 1000,
    someOtherProps: 'abc'
  }
}

export {
  config
}
